// extracted by mini-css-extract-plugin
export default {"container":"d9cWtH","controlsContainer":"c3gUqi","leftControls":"laSFXI","leftControlsInner":"B_42xw","rightControls":"VcOgv2"};